/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Campus_Callout_TitleInputs */

const en_dr_campus_callout_title = /** @type {(inputs: Dr_Campus_Callout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprints start in a Design Room`)
};

const id_dr_campus_callout_title = /** @type {(inputs: Dr_Campus_Callout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint dimulai dari Design Room`)
};

/**
* | output |
* | --- |
* | "Sprints start in a Design Room" |
*
* @param {Dr_Campus_Callout_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_campus_callout_title = /** @type {((inputs?: Dr_Campus_Callout_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Campus_Callout_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_campus_callout_title(inputs)
	return en_dr_campus_callout_title(inputs)
});